// Centralized constants & styles used by TirumalaDC.
// Moving these here does NOT change any behavior or styles.

export const styles = {
openButton: {
  padding: "10px 16px",
  backgroundColor: "#facc15",      // Flashaid yellow
  color: "#333",                   // dark text for contrast
  border: "none",
  borderRadius: "8px",
  fontFamily: '"Josefin Sans", sans-serif',
  fontWeight: 600,
  cursor: "pointer",
  boxShadow: "0 2px 6px rgba(250, 204, 21, 0.35)", // subtle yellow shadow
  transition: "background-color 0.2s ease, transform 0.1s ease",
},
  dialogOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dialog: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    width: "400px",
    maxHeight: "80vh",
    overflowY: "auto",
  }, // Added maxHeight and overflowY for scrolling
  dialogTitle: { fontSize: "18px", fontWeight: "bold" },
  formSelection: { display: "flex", justifyContent: "space-between", marginBottom: "10px" },
  button: {
    padding: "10px",
    cursor: "pointer",
    margin: "5px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "5px",
  },
  otpSection: { marginTop: "10px", textAlign: "center" },
  dialogContent: { marginTop: "10px" },
  question: { marginBottom: "10px" },
  label: { display: "block", marginBottom: "5px" },
  radioGroup: { display: "flex", gap: "10px" },
  radioLabel: { cursor: "pointer" },
  pdfSection: { marginTop: "10px", textAlign: "center" },
  link: { color: "blue", textDecoration: "underline" },
  footer: { marginTop: "10px", display: "flex", justifyContent: "space-between" },
  buttonCancel: { padding: "10px", backgroundColor: "red", color: "white" },
  buttonSave: { padding: "10px", backgroundColor: "blue", color: "white" },
};

export const healthQuestion = [
  {
    key: "medicalHistory",
    label:
      "Have you ever suffered from or taken treatment, been hospitalized, or been recommended to take any investigations/medical treatment?",
  },
  {
    key: "insuranceHistory",
    label:
      "Has any of your Insurance Proposal / Policy or reinstatement of policy for Life, Health, or Critical Illness ever been withdrawn, deferred, declined, rejected, terminated, or offered with an extra premium?",
  },
  {
    key: "covidHistory",
    label:
      "Have you ever been hospitalized for COVID infection or its complications, or do you have any ongoing complications related to COVID infection?",
  },
  {
    key: "hazardousActivities",
    label: "Are you currently engaged in any hazardous activities?",
  },
];

// Static assets/links (unchanged)
export const pdfDownloadLink =
  "https://storage.googleapis.com/flash-v2/assets/Long%20Form%20Medical%20Questionnaire.pdf";

export const memmberShipFormLink =
  "https://storage.googleapis.com/flash-v2/assets/aviva_membership_form.pdf";

// File caps (unchanged)
export const MAX_FILE_SIZE = 1024 * 1024; // 1 MB in bytes
